import React from 'react';

import { DialogUI } from '../Interface';
import { Box, Typography } from '@mui/material';
import { formatNumber } from '../../utils/currencyHelper';

const ItemsDialog = ({ open, handleClose, items, addItem }) => {
  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={'Találatok'}
      sx={{
        '& .MuiDialog-container': { alignItems: 'flex-start' },
        '& .MuiPaper-root': { width: '100%', maxWidth: '800px', height: '70vh' },
        '& .MuiDialogContent-root': { overflowY: 'auto', maxHeight: '100%' },
        marginTop: '40px',
      }}
    >
      {items?.length === 0 ? (
        <Box>Nincs találat.</Box>
      ) : (
        <Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {items?.map((evt, idx) => {
            const { itemCode, item, batchSn, binCode, whsCode, effectiveQty } = evt;

            return (
              <Box
                key={`${itemCode}-${batchSn || 'nobatch'}-${binCode || 'nobin'}-${idx}`}
                onClick={() => {
                  addItem(evt);
                  handleClose();
                }}
                sx={{
                  px: 1.5,
                  py: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  borderRadius: 1,
                  cursor: 'pointer',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
                  {itemCode} - {item?.itemName}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Raktár:{' '}
                  </Box>
                  {whsCode}
                </Typography>
                {binCode ? (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    component="div"
                    sx={{ display: 'block', mt: 0.25 }}
                  >
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      Rakhely:{' '}
                    </Box>
                    {binCode}
                  </Typography>
                ) : null}
                {batchSn ? (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    component="div"
                    sx={{ display: 'block', mt: 0.25 }}
                  >
                    <Box component="span" sx={{ fontWeight: 600 }}>
                      Sarzs:{' '}
                    </Box>
                    {batchSn}
                  </Typography>
                ) : null}

                <Typography
                  variant="caption"
                  color="text.secondary"
                  component="div"
                  sx={{ display: 'block', mt: 0.25 }}
                >
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    Elérhető mennyiség:{' '}
                  </Box>
                  {formatNumber(parseFloat(effectiveQty ?? 0))} {item?.quantityUnit?.code || ''}
                </Typography>
              </Box>
            );
          })}
        </Box>
      )}
    </DialogUI>
  );
};

export default ItemsDialog;
